import { render, staticRenderFns } from "./table-primary.vue?vue&type=template&id=71f02805&scoped=true"
import script from "./table-primary.vue?vue&type=script&lang=js"
export * from "./table-primary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f02805",
  null
  
)

export default component.exports